import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import {
  Medication,
  Prescription,
  PrescriptionMedicationStatus,
  PrescriptionMedicationFilterType,
} from '../types';

export const useUserMedicationsPrescriptions = ({
  userId,
  resource_type,
  status,
}: {
  userId?: string;
  resource_type?: PrescriptionMedicationFilterType;
  status?: PrescriptionMedicationStatus;
} = {}) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const queryStr = qs.stringify({ resource_type, status });

  const fetchUserMedicationsPrescriptions = async () => {
    const requestObj = {
      route: `/private/dashboard/user/${userId}/medications-prescriptions${
        queryStr ? `?${queryStr}` : ''
      }`,
      token: userToken,
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<
    (Medication | Prescription)[],
    Error
  >({
    queryKey: ['user-medications-prescriptions', userToken, userId, queryStr],
    queryFn: () => fetchUserMedicationsPrescriptions(),
    enabled: !!userId && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isError };
};
